import script from "./PluginAdminsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PluginAdminsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./PluginAdminsTableLoader.vue?vue&type=style&index=0&id=f2bb44c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2bb44c0"]])

export default __exports__